var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38384",
    "data-name": "Group 38384",
    transform: "translate(-10488.354 -1229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29845",
    "data-name": "Path 29845",
    d: "M126,56V69.623h13.623V56Zm9.731,9.731h-5.839V59.893h5.839Z",
    transform: "translate(10362.354 1173)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29846",
    "data-name": "Path 29846",
    d: "M126,373.33v13.624h13.623V373.33Zm9.731,9.732h-5.839v-5.839h5.839Z",
    transform: "translate(10362.354 888.046)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29847",
    "data-name": "Path 29847",
    d: "M443.34,56V69.623h13.623V56Zm9.731,9.731h-5.839V59.893h5.839Z",
    transform: "translate(10077.392 1173)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29848",
    "data-name": "Path 29848",
    d: "M453.063,224v11.677h-9.731v3.892h13.623V224Z",
    transform: "translate(10077.398 1022.119)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29849",
    "data-name": "Path 29849",
    d: "M443.34,410.67V420.4h3.892v-5.839h5.839V420.4h3.893V410.67Z",
    transform: "translate(10077.392 854.599)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29850",
    "data-name": "Path 29850",
    d: "M294,56v3.893h7.785v9.731h3.893V56Z",
    transform: "translate(10211.516 1173)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29851",
    "data-name": "Path 29851",
    d: "M301.781,224v7.785H294v11.677h7.785v9.731h3.893V239.57h-7.785v-3.892h7.785v-7.785h3.893v3.893h3.892V224Z",
    transform: "translate(10211.418 1021.806)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29852",
    "data-name": "Path 29852",
    d: "M294,448h3.893v5.839H294Z",
    transform: "translate(10211.58 821.161)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29853",
    "data-name": "Path 29853",
    d: "M200.66,298.67H206.5v3.892H200.66Z",
    transform: "translate(10295.344 955.212)",
    fill: "#000051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29854",
    "data-name": "Path 29854",
    d: "M143.516,130.66v9.731H126v11.677h3.893v-7.785h17.516V130.66Z",
    transform: "translate(10362.354 1105.906)",
    fill: "#000051"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.5a90f44da2df4f13ee811f22f6885fa1.svg";
export { ForwardRef as ReactComponent };